import React, { useEffect, useRef, useState } from "react";
import Slider from "../components/Hcomp/Slider";
import slides from "../components/Lcomp/SlidesData";
import Button from "../components/Lcomp/Button";
import Badge from "../components/Lcomp/Badge";
import MultiServices from "../components/Lcomp/MultiServices";
import SupportServices from "../components/Lcomp/SupportServices";
import About from "../components/Lcomp/About";
import OurSponsors from "../components/Lcomp/OurSponsors";
import Documentary from "../components/Lcomp/Documentary";
import STC from "../components/Lcomp/STC";
import WhatToExpect from "../components/Lcomp/WhatToExpect";
import CTA from "../components/Lcomp/CTA";
import SuccessStory from "../components/Lcomp/SuccessStory";
import Contact from "../components/Lcomp/Contactcomp";
import LatestNews from "../components/Hcomp/LatestNews";
import { Link } from "react-router-dom";
import SmallScreenSlider from "../components/Hcomp/SmallScreenSlider";
import slidesSm from "../components/Lcomp/SlidesDataSm";
import { FaAnglesDown } from "react-icons/fa6";
import { FaArrowDown } from "react-icons/fa6";
import { FaFilePdf, FaQuestionCircle } from "react-icons/fa";
import Researchcomp from "../components/Lcomp/Researchcomp";

const Homepage = () => {
  const [showArrow, setShowArrow] = useState(true);
  const [showDocumentary, setShowDocumentary] = useState(false);

  // Stats count state
  const [bmtCount, setBmtCount] = useState(0);
  const [clinicCount, setClinicCount] = useState(0);
  const hasAnimatedRef = useRef(false);

  // Replace these with your real numbers or props/API values
  const totalBMTs = 52;
  const totalClinics = 22;

  const statsRef = useRef(null);

  // Hide arrow on first scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowArrow(false);
      window.removeEventListener("scroll", handleScroll);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // show documentary popup after 3s
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDocumentary(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // Smooth count animation using requestAnimationFrame with easing
  const animateValue = (from, to, durationMs, setter) => {
    const start = performance.now();
    const range = to - from;
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    function frame(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / durationMs, 1);
      const eased = easeOutCubic(progress);
      const current = Math.round(from + range * eased);
      setter(current);
      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    }

    requestAnimationFrame(frame);
  };

  // IntersectionObserver to start animation when stats section enters view
  useEffect(() => {
    if (!statsRef.current) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -20% 0px", // trigger a bit earlier (adjust if necessary)
      threshold: 0.25, // 25% visible to trigger
    };

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && !hasAnimatedRef.current) {
        hasAnimatedRef.current = true;

        // animate counts
        animateValue(0, totalBMTs, 1800, setBmtCount); // 1.8s
        // slight stagger for nicer effect
        setTimeout(() => {
          animateValue(0, totalClinics, 2000, setClinicCount); // 2s
        }, 150);
      }
    }, observerOptions);

    observer.observe(statsRef.current);

    return () => {
      if (statsRef.current) observer.unobserve(statsRef.current);
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statsRef.current]);

  return (
    <section className="w-screen lg:mt-24 relative">
      {/* Documentary Popup */}
      {showDocumentary && (
        <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-xl w-[95%] md:w-[80%] lg:w-[70%] relative">
            <Documentary onClose={() => setShowDocumentary(false)} />
          </div>
        </div>
      )}

      {/* Landing Content */}
      <div className="relative md:pt-[6.5rem] lg:pt-0 h-max">
        <Slider slides={slides} />
        <SmallScreenSlider slidesSm={slidesSm} />

        <div className="absolute top-[25%] md:top-[35%] lg:top-[25%] z-20 w-full lg:w-[55%] h-auto px-[1.5rem] sm:px-16 text-white text-center lg:text-start">
          <h1 className="text-[34px] md:text-[38px] lg:text-[48px] leading-[1.2] md:leading-[1] lg:leading-[3.4rem] tracking-wide capitalize font-bold text_shadow_">
            Providing, safe, quality, accessible and Affordable{" "}
            <span className="text-red-600">Bone Marrow Transplant</span> for
            persons living with Sickle Cell Disorder
          </h1>

          <p className="text-[19px] lg:text-[18px] text-center sm:text-start md:text-center lg:text-start 3xl:text-center my-8 md:my-4 lg:my-8 w-[90%] lg:w-full mx-auto lg:mx-0 text_shadow_ tracking-wide leading-normal md:leading-[1.4] lg:leading-normal">
            The First Comprehensive Bone Marrow Transplant Center In
            West-Africa!
          </p>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-[auto_auto_1fr] gap-4 w-full">
            <Link
              to="https://docs.google.com/forms/d/e/1FAIpQLScJGyYtNBHX2yN0GqyeMchSxvdnSfZ7P-1Eo6AOQzD_0yaelA/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto"
            >
              <Button
                classes="px-[28px] py-[12px] bg-primary_red font-Lexend font-bold rounded-[4px] text-[14px] hover:bg-primary_red/80 trans_animate tracking-wider w-full md:w-auto text-center whitespace-nowrap"
                text="BMT Preliminary Inquiry"
              />
            </Link>

            <Link to="/about#tour-facility" className="w-full md:w-auto">
              <Button
                classes="px-[28px] py-[12px] bg-primary_green font-Lexend font-bold rounded-[4px] text-[14px] hover:bg-primary_green/80 trans_animate tracking-wider w-full md:w-auto text-center whitespace-nowrap"
                text="Our Facility Tour"
              />
            </Link>

            <Link to="/contact" className="w-full">
              <Button classes="px-[28px] py-[12px] bg-black text-white font-Lexend font-bold rounded-[4px] text-[14px] hover:bg-black/80 trans_animate tracking-wider w-full text-center whitespace-nowrap flex items-center justify-center gap-2">
                <span>Begin Your Journey</span>
                <FaArrowDown className="text-[14px] animate-bounce" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="w-full absolute bottom-20 md:bottom-36 z-50 flex items-center justify-center md:hidden lg:flex">
          {showArrow && (
            <FaAnglesDown className="text-4xl text-white/80 shadow-md bounce-animation rounded-full font-extralight" />
          )}
        </div>
      </div>

      {/* Stats Section */}
      <section
        id="stats-section"
        ref={statsRef}
        className="relative w-full py-20 bg-primary_dark text-white flex flex-col md:flex-row items-center justify-center gap-16 overflow-hidden"
      >
        {/* ✅ LEFT STAT */}
        {/* <div className="text-center">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-extrabold leading-none">
            {bmtCount}+
          </h2>
          <p className="text-lg md:text-xl mt-3">
            Bone Marrow Transplants Done
          </p>
        </div> */}

        {/* ✅ RIGHT STAT */}
        {/* <div className="text-center">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-extrabold leading-none">
            {clinicCount}+
          </h2>
          <p className="text-lg md:text-xl mt-3">
            Post-Transplant Clinic Sessions
          </p>
        </div> */}

        {/* ✅ MOBILE — Bottom Center */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 md:hidden">
          {/* Brochure */}
          <a
            href="/documents/BMT_brouchure.pdf"
            download
            className="flex items-center gap-2 px-5 py-3 bg-red-600 text-white font-bold rounded-md text-xs shadow-lg hover:bg-red-500 transition"
          >
            <FaFilePdf className="text-white text-sm" />
            Brochure
          </a>

          {/* FAQ */}
          <a
            href="/documents/BMT FAQ.pdf"
            download
            className="flex items-center gap-2 px-5 py-3 bg-blue-600 text-white font-bold rounded-md text-xs shadow-lg hover:bg-blue-500 transition"
          >
            <FaQuestionCircle className="text-white text-sm" />
            FAQ
          </a>
        </div>

        {/* ✅ DESKTOP — Bottom Left */}
        <div className="hidden md:block absolute bottom-6 left-6">
          <a
            href="/documents/BMT_brouchure.pdf"
            download
            className="flex items-center gap-3 px-6 py-3 bg-red-600 text-white font-bold rounded-md text-sm shadow-xl hover:bg-red-500 transition"
          >
            <FaFilePdf className="text-white text-lg" />
            Download Brochure
          </a>
        </div>

        {/* ✅ DESKTOP — Bottom Right */}
        <div className="hidden md:block absolute bottom-6 right-6">
          <a
            href="/documents/BMT FAQ.pdf"
            download
            className="flex items-center gap-3 px-6 py-3 bg-blue-600 text-white font-bold rounded-md text-sm shadow-xl hover:bg-blue-500 transition"
          >
            <FaQuestionCircle className="text-white text-lg" />
            Download FAQ
          </a>
        </div>
      </section>

      <Badge />
      <MultiServices />
      <SupportServices />
      <About />
      <STC />
      <WhatToExpect />
      <Researchcomp />
      <CTA />
      <SuccessStory />
      <OurSponsors />
      <Contact />
      <section id="latest-news">
        <LatestNews />
      </section>
    </section>
  );
};

export default Homepage;
